import { useEffect, useState } from "react";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { disableSupportPush, enableSupportPush, existingPushSubscription, pushSupported } from "@/lib/supportPush";

export const SupportPushButton = () => {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    existingPushSubscription().then(subscription => setEnabled(!!subscription)).catch(() => {});
  }, []);

  const toggle = async () => {
    setBusy(true); setError("");
    try {
      if (enabled) { await disableSupportPush(); setEnabled(false); }
      else { await enableSupportPush(); setEnabled(true); }
    } catch (e) { setError(e?.response?.data?.detail || e.message || "Notifiche non disponibili"); }
    finally { setBusy(false); }
  };

  if (!pushSupported()) return (
    <p className="text-xs text-[#707070]" data-testid="support-push-unsupported">
      Le notifiche del browser non sono disponibili qui. Gli avvisi restano nell'area Assistenza.
    </p>
  );
  return (
    <div className="text-right">
      <Button type="button" variant="outline" onClick={toggle} disabled={busy}
              className="gap-2 border-[#D8D2C6] rounded-sm text-[#1A1A1A]"
              data-testid="support-push-toggle">
        {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : enabled ? <BellOff className="w-4 h-4"/> : <Bell className="w-4 h-4"/>}
        {busy ? "Attendi..." : enabled ? "Disattiva push" : "Attiva push"}
      </Button>
      {error && <p role="alert" className="text-xs text-[#8C3A3A] mt-2" data-testid="support-push-error">{error}</p>}
    </div>
  );
};